import { useQuery } from '@tanstack/react-query'
import { fetchDashboard } from '@/services/readerService'
import type { LibraryItem } from '@/types/api'
import { isPalavras } from '@/services/palavrasBrand'

export function StudentDashboard({ onOpen }: { onOpen: (item: LibraryItem) => void }) {
  const { data, isError, refetch } = useQuery({ queryKey: ['student-dashboard'], queryFn: fetchDashboard, refetchOnMount: 'always' })
  if (isError) return <p role="status">Resumo indisponível. <button onClick={() => void refetch()}>Tentar novamente</button></p>
  if (!data) return <p role="status">Carregando seu resumo…</p>
  return <section className="student-dashboard" aria-label="Resumo de leitura">
    <h2>{isPalavras() ? 'Palavras Educação' : data.brand.name} · Minha leitura</h2>
    <p>{data.available} de {data.books} livros PDF disponíveis para leitura.</p>
    {data.continue_reading ? <button type="button" onClick={() => onOpen(data.continue_reading!.item)}>
      Continuar {data.continue_reading.item.title}{data.continue_reading.page ? ` · página ${data.continue_reading.page}` : ''}
    </button> : <p>Escolha um livro disponível abaixo para começar.</p>}
  </section>
}
